<template>
    <div>
        <!-- 顶部菜单 -->
        <div class="breadcrumbTop">
            <el-breadcrumb separator="/">
                <span class="el-breadcrumb__item index">
                    <router-link to="/">首页</router-link>
                    <span class="el-breadcrumb__separator">/</span>
                </span>
                <el-breadcrumb-item
                    :to="{ path: item.path }"
                    v-for="(item, index) in breadList"
                    :key="index"
                >
                    {{ item.meta }}</el-breadcrumb-item
                >
            </el-breadcrumb>
        </div>
        <div class="centerTop">
            <el-dropdown style="margin-right:30px" @command="powerShopCur">
                <span class="el-dropdown-link">
                    {{ names }}
                    <i
                        class="el-icon-arrow-down el-icon--right"
                        v-if="powerShop.length == 1 ? false : true"
                    ></i>
                </span>
                <el-dropdown-menu
                    slot="dropdown"
                    v-if="powerShop.length == 1 ? false : true"
                >
                    <el-dropdown-item
                        v-for="(item, index) in powerShop"
                        :key="index"
                        :command="item"
                        :class="cur == item.mchid ? 'active' : ''"
                    >
                        {{ item.merchant_shorter_name }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown @command="handleFunction">
                <span class="el-dropdown-link">
                    {{ usernames }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                        v-for="(item, index) in centerMenu"
                        :key="index"
                        :command="item.callBack"
                    >
                        {{ item.title }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <!-- 企业通讯录配置 -->
        <el-dialog
            title="企业通讯录配置"
            :visible.sync="dialogVisible"
            :show-close="false"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
        >
            <configuration
                @isDialogVisible="isDialogVisible"
                @configLS="configLS"
            ></configuration>
        </el-dialog>
        <!-- 修改密码 -->
        <el-dialog
            title="修改密码"
            :visible.sync="changeDolog"
            :show-close="false"
            custom-class="listDialog"
            width="500px"
            @close="$refs.forgetForm.resetFields()"
        >
            <el-form
                :model="forgetData"
                ref="forgetForm"
                label-width="120px"
                class="login_form"
            >
                <el-form-item
                    label="新密码"
                    prop="pass"
                    :rules="[{ required: true, message: '请输入新密码' }]"
                >
                    <el-input
                        show-password
                        v-model.trim="forgetData.pass"
                        placeholder="由4-6位数字 字母组成"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="确认密码"
                    prop="newPass"
                    :rules="[{ required: true, message: '请确认密码' }]"
                >
                    <el-input
                        show-password
                        v-model.trim="forgetData.newPass"
                        placeholder="请确认密码"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    size="small"
                    @click="submitForm('forgetForm')"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import configuration from '@/components/configuration/index.vue'
export default {
    components: { configuration },
    data() {
        return {
            forgetData: {
                pass: '',
                newPass: '',
            },
            dialogVisible: false,
            cur: '',
            breadList: [],
            centerMenu: [
                {
                    title: '修改密码',
                    callBack: 'changePass',
                },
                {
                    title: '退出登陆',
                    callBack: 'loginOut',
                },
            ],
            powerShop: [],
            names: '',
            usernames: '',
            changeDolog: false,
        }
    },
    watch: {
        $route() {
            this.getBreadcrumb()
        },
    },
    created() {
        let options = this.$commonFun.getUrlParam()
        var code = options.auth_code
        if (this.$store.state.app.temporaryAccessToken || code) {
            if (code) {
                if (this.$store.state.app.merchantAccessToken) {
                    this.$store.dispatch('stateClear')
                }
                if (this.$store.state.app.temporaryAccessToken) {
                    this.dialogVisible = true
                    return
                }
                this.$api
                    .workLogin({ code: code })
                    .then((res) => {
                        if (res.synchro) {
                            this.$store.dispatch('setTemporary', res.token)
                            //引导去设置相关配置
                            this.$store.commit('getSynchro', res.synchro)
                            this.dialogVisible = true
                        } else {
                            //基础设置已更新完成
                            this.$store.dispatch('setToken', res.token)
                            this.$store.dispatch('myStore', res.merchant)
                            location.href = '/merchant'
                        }
                    })
                    .catch((errCode) => {
                        location.href = '/merchant#/login'
                    })
            }
        } else {
            this.configLS()
        }
    },
    mounted() {
        this.getBreadcrumb()
    },
    methods: {
        submitForm(formName) {
            let _self = this
            _self.$commonFun.debounce(() => {
                _self.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (_self.forgetData.pass != _self.forgetData.newPass)
                            return _self.$commonFun.toast(
                                '两次密码不一致',
                                'error'
                            )
                        if (
                            !_self.$commonFun.isPasswd(_self.forgetData.newPass)
                        )
                            return _self.$commonFun.toast(
                                '只能输入4-6个字母、数字',
                                'error'
                            )
                        _self.$api
                            .changePassword({
                                newPassword: _self.forgetData.newPass,
                            })
                            .then((res) => {
                                _self.$commonFun.toast('修改成功', 'success')
                                _self.changeDolog = false
                            })
                    }
                })
            }, 500)
        },
        changePass() {
            this.changeDolog = true
        },
        isDialogVisible() {
            this.dialogVisible = false
        },
        configLS() {
            this.$api.merchantLS().then((res) => {
                if (!res.length) {
                    return this.loginOut()
                }
                this.$store.commit('myStore', res)
                this.names = this.$store.state.app.myStoreCur.merchant_shorter_name
                this.usernames = this.$store.state.app.myStoreCur.username
                this.cur = this.$store.state.app.myStoreCur.mchid
                this.powerShop = res
                this.$EventBus.$emit('aMsg')
            })
        },
        async powerShopCur(item, index) {
            const res = await this.$api.switchMerchant({ mchid: item.mchid })
            this.$store.dispatch('setToken', res)
            this.$store.commit('myStoreCur', item)
            this.$nextTick(() => {
                window.location.reload()
            })
        },
        //接收自定义方法事件
        handleFunction(action) {
            this[action]()
        },
        //设置面包屑
        getBreadcrumb() {
            let matched = this.$route.matched
            let breadList = []
            matched.forEach(function(item, index) {
                if (item.meta.title && item.meta.title !== '首页') {
                    breadList.push({
                        path: item.path,
                        meta: item.meta.title,
                    })
                }
            })
            this.breadList = breadList
        },

        //退出登录
        loginOut() {
            //清楚所有state
            this.$store.dispatch('stateClear')
            this.$store.dispatch('temporaryClear')
            localStorage.clear()
            sessionStorage.clear()
            this.$commonFun.jumpPage('/login', 1)
        },
    },
}
</script>
<style lang="scss">
.breadcrumbTop {
    float: left;
    .el-breadcrumb {
        line-height: 50px !important;
        .el-breadcrumb__item.index {
            font-weight: 700;
            text-decoration: none;
            transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            color: #303133;
        }
    }
}

.centerTop {
    float: right;
    height: 50px;
    line-height: 50px;
    transition: all 0.8s;
    padding: 0 8px;
    cursor: pointer;
    .el-popover__reference {
        color: #888;
        cursor: pointer;
    }
}

.el-dropdown-menu {
    .active {
        color: #2d8cf0 !important;
    }
}
</style>
